import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Edit, Eye, ChartBar, Trash } from "lucide-react";
import { NewsletterTemplate } from "../../types";
import { TemplateContentDisplay } from "../../components/TemplateContentDisplay";

interface TemplateCardProps {
  template: NewsletterTemplate;
  onEdit: (template: NewsletterTemplate) => void;
  onView: (template: NewsletterTemplate) => void;
  onSelect: (id: string) => void;
  onDelete: (template: NewsletterTemplate) => void;
}

export const TemplateCard = ({ 
  template, 
  onEdit, 
  onView, 
  onSelect, 
  onDelete 
}: TemplateCardProps) => {
  return (
    <Card className="hover:bg-accent/5 transition-colors">
      <CardContent className="p-6">
        <div className="flex justify-between items-start mb-4">
          <div>
            <h3 className="text-lg font-semibold">{template.name}</h3>
            <p className="text-sm text-muted-foreground">{template.template_type}</p>
          </div>
          <div className="flex gap-2">
            <Button 
              variant="ghost" 
              size="icon"
              onClick={() => onEdit(template)}
            >
              <Edit className="h-4 w-4" />
            </Button>
            <Button 
              variant="ghost" 
              size="icon"
              onClick={() => onView(template)}
            >
              <Eye className="h-4 w-4" />
            </Button>
            <Button 
              variant="ghost" 
              size="icon" 
              onClick={() => onSelect(template.id)}
            >
              <ChartBar className="h-4 w-4" />
            </Button>
            <Button 
              variant="ghost" 
              size="icon"
              onClick={() => onDelete(template)}
            >
              <Trash className="h-4 w-4" />
            </Button>
          </div>
        </div>
        <div className="space-y-4">
          <p className="text-sm text-muted-foreground line-clamp-2">
            {template.description || "No description available"}
          </p>
          <div className="mt-4 text-sm text-muted-foreground">
            <p>Versions: {template.newsletter_template_versions?.length || 0}</p>
          </div>
          <TemplateContentDisplay template={template} />
        </div>
      </CardContent>
    </Card>
  );
};